import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getMySocietyProfile } from "../../api/societyRequest";

const ProtectedSocietyRoute = ({ children }) => {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    getMySocietyProfile()
      .then(() => setStatus("allowed"))
      .catch(() => setStatus("denied"));
  }, []);

  if (status === "loading") return null;
  if (status === "denied") return <Navigate to="/homepage" replace />;

  return children;
};

export default ProtectedSocietyRoute;
